<template>
    <div class="business">
    <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
    />

    <div>
        <div class="bulkUploadClass" v-if="uploadMethod =true">
            <div class="download-btn">
                <download-button 
                onclick="location.href=' https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/EmployeeStatusTemplate.xlsx'">
                </download-button>
            </div>
            <div class="margin-t-15px">
                <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />
            </div>
        </div>
      
  

      <pop-up-message
        v-if="showSuccessMsg"
        :message="`<130/130> Field Form <Bulk_Upload_File.xls> Successfully Uploaded.`"
        btnText="OK"
        @back="goToBack"
      ></pop-up-message>

        <pop-up-message
        v-if="showSuccessBulkUploadMsg"
        :message="responseMsg"
        btnText="Back"
        @back="goToBack"
      ></pop-up-message>
      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Back" type="secondary" @click="closePopup()"/>
              <btn text="Save" type="primary" @click ="savePlan()"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { api_variables } from "@/apis/variables.js";
export default {
    name: "holdStopReleasePopup",
    props: {
  },
  data() {
    return {
      bulkUploadUrl: api_variables.SERVICE_BULK_UPLOAD,
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
    };
  },
  computed: {},

  mounted() {
    this.showSuccessMsg = false;
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    ...mapActions({
         act_upload_template: "dashboard/payroll/utilities/holdsalary/uploadTemplate",
    }),
      closePopup() {
        this.$emit('hidepopup');
      },
      savePlan() {
        this.showSuccessMsg = true;
        //console.log("Stop data");
      },

      goToBack() {
        this.showSuccessBulkUploadMsg = false;
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/hold_release_salary`,
      });
      this.$emit('hidepopup');
      window.location.reload();
    },
     /* function to get response after uploading in bulk */
    async onUploadTemplate(res) {
      try {
          if (res.data && res.data.status) {
            this.responseMsg = res.data.message ? res.data.message : "";
            this.showSuccessBulkUploadMsg = true;
          } else {
            this.toast = true;
            this.errmsg = res.message;
          }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.uploadDiv {
  width: 10%;
  margin-left: auto;
  text-align: center;
  justify-content: end;
  padding: 4px 0px 0px 0px;
  button {
    cursor: pointer;
    width: 60%;
    height: 70%;
    border-radius: 4px;
    color: #5d409f;
    border: 1px solid #5d409f;
  }
  img {
    height: 70%;
    margin-bottom: -6px;
  }
}
.lop-report {
  display: grid;
  grid-template-columns: 0.3fr 0.3fr 0.3fr auto;
  grid-gap: 10px;
}
.export-emp {
  float: right;
  margin-bottom: 1%;
  margin-top: 3%;
}
.export-section {
  margin-left: 12%;
  margin-top: 5px;
  align-items: center;
  display: flex;
}
.export-button {
  width: 85px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 5px;
  margin-right: 10px;
}
.sorttext {
  // width: 10%;
  text-align: center;
  line-height: 30px;
  color: #726f75;
  padding: 0px 0px 0px 10px;
}
.sorticons {
  width: 13%;
  padding: 8px 0px 5px 10px;
  span {
    padding-top: 10px;
    padding-left: 10px;
    border-left: 2px solid #34c0be;
  }
}
.cardClass {
  margin-bottom: 2%;
}
.download-btn {
  margin-top: 2%;
}
.upload {
  display: flex;
  width: 30%;
  margin-top: 2%;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
      to right,
      lightgray 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  height: 140px;
}
.upload-button {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    border: 1px solid #5d409f;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 15px;
    color: #5d409f;
  }
  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  img {
    height: 19px;
    width: 19px;
    margin-right: 8px;
  }
}
.details {
  color: #979797;
  font-size: 11px;
  b {
    color: #535353;
  }
}
</style>